import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  useFetchPolicy,
  usePolicyManagementFine,
  usePolicyManagementPolicy,
  useSetPolicyFine,
} from '../../../store/PolicyManagement/policyManagementHooks';
import QuestionModal from '../../shared/QuestionModal/QuestionModal';
import {
  useCloseOldModal,
  useModalData,
} from '../../../store/modal/modalHooks';
import { calculatePolicyFine } from '../../../utility/services/policy-calculate';
import { SubscriptionManagement } from '../../../store/SubscriptionsManagement/subscriptionsManagementTypes';

const CancelMembershipModal = () => {
  const { t } = useTranslation();
  const modalData = useModalData();
  const closeModal = useCloseOldModal();

  const fetchPolicy = useFetchPolicy();
  const setPolicyFine = useSetPolicyFine();
  const policy = usePolicyManagementPolicy();
  const policyFine = usePolicyManagementFine();

  const subscription: SubscriptionManagement = modalData?.data?.subscription;

  if (!subscription) {
    closeModal();
  }
  useEffect(() => {
    if (policy.id !== subscription.policyId) {
      fetchPolicy(subscription.policyId).finally();
    }
  }, [subscription]);

  useEffect(() => {
    const policyFine = calculatePolicyFine(subscription.fromDate, policy);
    setPolicyFine(policyFine);
  }, [policy]);

  return (
    <QuestionModal
      title={t('CANCEL_MEMBERSHIP_MODAL_TITLE')}
      subTitle={
        policyFine
          ? t('CANCELLATION_POLICY_FINE_MESSAGE', { fine: policyFine })
          : t('REMOVE_MODAL_SUBTITLE')
      }
      confirmButtonText={t('CANCELLATION_MODAL_CONFIRM_BUTTON')}
      cancelButtonText={t('REMOVE_MODAL_CANCEL_BUTTON')}
    />
  );
};

export default CancelMembershipModal;
